//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionTrashFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.16994 22H17.8399L18.8199 9.00003H5.18994L6.16994 22Z" fill="currentColor" /><path d="M20.4201 4.55002L20.0701 2.58002L14.9501 3.47002L13.9601 2.63002L9.10008 3.49002L8.44008 4.62002L3.33008 5.51002L3.67008 7.49002L20.4201 4.55002Z" fill="currentColor" /></svg>;
}
export default IconActionTrashFill;